<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="Normal">For BAFFIX, </p>
<p class="Normal">May your ideas be your wings</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?6236dd71